import styled from "styled-components";

export const SearchForm = styled.form.withConfig({displayName:'-SearchForm'})`
	background-color:  #164886;
  padding: 10px;
  color: #ffffff;
  font-size: 12px;
`;
export const SearchRow = styled.div.withConfig({displayName:'-SearchRow'})`
	display: grid;
  // flex-direction: row;
	grid-template-columns: 1.5fr 1fr 1fr;
	gap: 8px;
	margin-bottom: 10px;
	&:last-child {
		margin-bottom: 0;
	}
`;
export const SearchElement = styled.div.withConfig({displayName:'-SearchElement'})`
	flex: 1;
	display: flex;
	flex-direction:column;
	align-items: start;
`;
export const SearchLabel = styled.label`
	display: block;
	margin-bottom: 0;
`;
export const SearchSelectGroup = styled.div.withConfig({displayName:'-SearchSelectGroup'})`
	display: flex;
	flex-direction: row;

	& > div:nth-child(1){
		flex-grow: 0;
		flex-shrink: 0;
	}
	& > div:nth-child(2){
		flex-grow: 1;
		flex-shrink: 1;
	}

	& > div:not(:first-child) > div > div{
		border-top-left-radius: 0px;
		border-bottom-left-radius: 0px;
		border-left: 0px;
	}
	& > div:not(:last-child) > div > div{
		border-bottom-right-radius: 0px;
		border-top-right-radius: 0px;
	}
`;